{#if isLink || href}
  <a {...attr}
     class:disabled
     role="button"
     href={href ?? 'javascript:void(0);'}
     target={external ? '_blank' : '_self'}
     on:click>
    <slot />
  </a>
{:else}
  <button {...attr}
          class:disabled
          disabled={disabled}
          on:click>
    <slot />
  </button>
{/if}

<script >var _a;
;
import { computeClasses, getDomAttributes } from '../utils';
export let type = null;
export let size = 'default';
export let block = false;
export let disabled = false;
export let outline = null;
export let isLink = false;
export let href = null;
export let external = false;
let attr;
$: {
    attr = getDomAttributes({
        props: $$restProps,
        classes,
    });
}
let classes;
$: classes = `paper-btn ${(_a = $$restProps.class) !== null && _a !== void 0 ? _a : ''} ${computeClasses('btn', { size, block, type, outline })}`;
</script>
